/* eslint-disable */
// because legacy

import { defaultPost } from '@bikemap/js/utility'
import { gettext, context, modals, notifications } from '@bikemap/js/services'

const Stripe = window.Stripe

function handlePlanUpgradeConfirm(e, modal) {
    modal.setLoading()
    defaultPost(modal.referrer.action, new FormData(modal.referrer))
        .then(({ callback_params, url }) => {
            if (callback_params.client_secret) {
                // we need stripe here
                const stripe = new Stripe(context.page('stripePublicKey'))
                if (callback_params.client_secret.payment_intent_client_secret) {
                    stripe.handleCardPayment(
                        callback_params.client_secret.payment_intent_client_secret
                    ).then(function (result) {
                        if (result.error) {
                            notifications.show({
                                title: gettext('Error'),
                                icon: 'i-warning-sign',
                                message: result.error.message,
                                type: 'danger',
                            })
                        } else if (url) {
                            location.href = url
                        } else {
                            location.reload()
                        }
                    })
                } else if (callback_params.client_secret.setup_intent_client_secret) {
                    stripe.handleCardSetup(
                        callback_params.client_secret.setup_intent_client_secret,
                    ).then(function (result) {
                        if (result.error) {
                            notifications.show({
                                title: gettext('Error'),
                                icon: 'i-warning-sign',
                                message: result.error.message,
                                type: 'danger',
                            })
                        } else if (url) {
                            location.href = url
                        } else {
                            location.reload()
                        }
                    })
                }
            } else if (url) {
                if (location.href === url) {
                    location.reload()
                } else {
                    location.href = url
                }
            }
        })
        .catch(res => {
            res.json().then(res => {
                notifications.show({
                    title: res.title,
                    icon: 'i-warning-sign',
                    message: res.message,
                    type: 'danger',
                })
            })
        })
        .finally(() => {
            modal.setLoading(false)
            modals.close()
        })
}

export function initUpgradeSubscriptionForm() {
    const upgradeTo3YearsForm = document.getElementById('upgrade-to-3-years')

    if (upgradeTo3YearsForm) {
        const message = gettext('Pay once and get access to all exclusive Bikemap Premium features for 3 years. Enjoy all advantages for {price}.')
            .replace('{price}', upgradeTo3YearsForm.dataset.amount)
        upgradeTo3YearsForm.addEventListener('submit', e => {
            e.preventDefault()
            modals.show('plan-upgrade-modal', {
                header: (
                    '<svg class="premium-badge" style="width: 100%; height: 130px; margin: -65px auto 20px auto;">' +
                        '<use xlink:href="#premium-badge" />' +
                    '</svg>'
                ),
                title: gettext('Upgrade Membership'),
                message,
                buttons: [
                    { content: gettext('Yes, upgrade now'), style: 'success', action: 'submit' },
                    { content: gettext('Cancel'), action: 'close' },
                ],
                referrer: upgradeTo3YearsForm,
                onSubmit: handlePlanUpgradeConfirm,
            })
        })
    }
}
